import * as actionTypes from './actionTypes';
import axios from "../axiosApi";
import {FETCH_ESTABELECIMENTOS} from "./actionTypes";
import {RECEIVE_ESTABELECIMENTOS} from "./actionTypes";
import {SET_FILTER_ESTABELECIMENTO} from "./actionTypes";



export const fetchEstabelecimentos =  () => ({
    type: FETCH_ESTABELECIMENTOS
});

export const receiveEstabelecimentos = payload => ({
    type: RECEIVE_ESTABELECIMENTOS,
    payload: payload
});

export const onChangeFilter = (newVal) => ({
    type: actionTypes.CHANGE_FILTER,
    payload: newVal
})

export const changeFilter = (newVal) => ({
    type: actionTypes.CHANGE_FILTER,
    payload: newVal
})

export const dpNothing = () => ({
    type: 'NOTHING',
    payload: {}
})


export const getEstabelecimentos = () => {
    return async (dispatch, getState) => {

        const bMock = getState().i4.mock;
        console.log("getEstabelecimentos bMock", bMock);
        if (bMock) {
            console.log("getEstabelecimentos Mock");
            return;
        }

        dispatch(fetchEstabelecimentos());
        let payload = {};
        try {
            console.log("getEstabelecimentos.ESTABELECIMENTOS ")
            const response = await axios.get(`/estabelecimentos`)
             console.log("getEstabelecimentos.ESTABELECIMENTOS response", response)
            payload = response.data;

        }
        catch(e) {
            console.log("getEstabelecimentos.ESTABELECIMENTOS FAIL TRIGGERED");

            payload = { error: true, e: e, data: [] };
        }
        finally {
            console.log('getEstabelecimentos.finally', payload)
            dispatch(receiveEstabelecimentos(payload));
        }
    }
};


export const setEstabelecimento = (estab) => {
    return (dispatch, getState) => {

        dispatch({
            type: SET_FILTER_ESTABELECIMENTO,
            payload: estab
        })
    }

}
